import React, { useEffect, useState } from 'react'
import { useLocation, useHistory, Link } from 'react-router-dom'

import { Modal } from 'antd'

import { Table, Layout, Space, Row, Col, Button } from 'antd'
import {
  EditOutlined,
  DeleteOutlined
} from "@ant-design/icons"

import usePaginate from '../../firebase/hooks/usePaginate'
// import FireStoreSearch from '../../reusable/FireStoreSearch'
import { useStore } from "../../contexts/FireStoreContext"
import FireStoreSearch from "../../components/FilterSearch"
import { useAuth } from "../../contexts/AuthContext"
import PageLimitDropDown from "../../components/PageLimitDropDown"

const { Content } = Layout

const table = "banks"
const where = []

const searchOptions = [
  {
    'key': 'bank',
    'label': 'Bank Name'
  },
  {
    'key': 'country',
    'label': 'Country'
  }
]

const List = () => {
  const history = useHistory()
  const { pathname } = useLocation()
  const { deleteDocument } = useStore()
  const { user } = useAuth()
  const [list, setList] = useState([])
  const [showMore, setShowMore] = useState(true)

  const {
    loading,
    loadingMore,
    hasMore,
    items,
    loadMore
  } = usePaginate(table, {
    where: where,
    // where: ["firstName", "==", 'John'],
    orderBy: ["bank", "asc"],
    limit: user.limit
  })

  useEffect(() => {
    setList(items)
  }, [items])

  console.log(list)

  const setResult = async (list, searchLength) => {
    if (searchLength > 1) {
      setList(list)
      setShowMore(false)
    } else {
      setList(items)
      setShowMore(true)
    }
  }

  const columns = [
    {
      title: 'Bank',
      dataIndex: 'bank',
      key: 'bank',
      // filters: {},
      // sorter: true,
      sorter: (a, b) => a.bank.length - b.bank.length,
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      // sorter: true,
      sorter: (a, b) => a.type.length - b.type.length,
      sortDirections: ['ascend', 'descend'],
      responsive: ['md'],
      render: (type) => <span>{type}</span>
    },
    {
      title: 'Countries',
      dataIndex: 'country',
      key: 'country',
      // sorter: true,
      sorter: (a, b) => a.country.length - b.country.length,
      sortDirections: ['ascend', 'descend'],
      responsive: ['md'],
      render: (country, row) => <span>{country} ({row.iso2}) </span>
    },
    // {
    //   title: 'Date',
    //   dataIndex: 'createdAt',
    //   key: 'createdAt',
    //   render: createdAt => (createdAt.toDate())
    // },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'id',
      render: (id, row) => (
        <Space size="middle">
          <EditOutlined onClick={() => editItem(row)} />
          <DeleteOutlined style={{ color: "#ff0000" }} onClick={() => deleteConfirm(row)} />
        </Space>
      )
    }
  ]

  const deleteConfirm = (item) => {
    Modal.confirm({
      title: "Are you sure?",
      content: <>
        <div>You want to delete <b>{item.bank}</b>?</div>
        <small>After delete, Data can't be recovered.</small>
      </>,
      centered: true,
      // onCancel: handleCancel,
      cancelText: "No",
      onOk: () => deleteDocument(table, item.id, item.bank),
      okText: "Yes",
      cancelButtonProps: {
        danger: true
      },
      okButtonProps: {
        danger: true
      }
    })
  }

  const editItem = (item) => {
    history.push(`${pathname}/edit/${item.id}`, item)
  }

  // const viewItem = (e, item) => {
  //   history.push(`${pathname}/edit/${item.id}`, item)
  // }

  const onChange = (data) => {
    console.log(data)
  }

  return (
    <Content>
      {/* <Breadcrumb>
        <Breadcrumb.Item>Banks</Breadcrumb.Item>
      </Breadcrumb> */}
      <div className="" style={{ padding: 16, minHeight: 360 }}>
        <Row justify="space-between">
          <Col xs={18} lg={6}>
            <FireStoreSearch table={table} searchOptions={searchOptions} setResult={setResult} />
          </Col>
          <Col xs={6} lg={18} className="text-right">
            <Button type="primary" style={{ marginBottom: "1em" }}><Link to={`${pathname}/add`}>Add Bank</Link></Button>
          </Col>
        </Row>
        <Table
          rowKey="id"
          dataSource={list}
          columns={columns}
          loading={loading}
          onChange={onChange}
          pagination={false}
        />
        <Row justify="space-between" style={{ marginTop: "1.5em" }}>
          <Col>
            <PageLimitDropDown />
          </Col>
          <Col>
            {showMore && hasMore && !loadingMore && <Button type="primary" onClick={loadMore}>Load More</Button>}
            {loadingMore && <Button type="primary" loading>Loading...</Button>}
          </Col>
        </Row>
      </div>
    </Content>
  )
}

export default List
